import { render } from "./FixNodes.vue?vue&type=template&id=0e64fa6c&ts=true"
import script from "./FixNodes.vue?vue&type=script&lang=ts"
export * from "./FixNodes.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__